import { useCallback } from "react";
import { useStateValue } from "../context-store/AppStateProvider";
import fetch from "unfetch";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const usePost = (endpointPath) => {
  const [{ token }] = useStateValue();

  const postDataCallback = useCallback(
    async (payload) => {
      const options = {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + token
        },
        referrerPolicy: "no-referrer",
        body: JSON.stringify(payload),
      };

      try {
        const res = await fetch(
          `${API_BASE_URL}/${endpointPath}`,
          {
            ...options,
          }
        );
        const json = await res.json();

        if (!res.ok) {
          return { response: null, error: res };
        }

        return { response: json, error: null };
      } catch (err) {
        return { response: null, error: err };
      }
    },
    [endpointPath, token]
  );

  return { postDataCallback };
};

export default usePost;
